// extracted by mini-css-extract-plugin
module.exports = {"iframe-container":"IFrame_iframe-container__2mgI1"};